export const LOCALES = ['en', 'ar'] as const;

export const PAGE_DIRECTIONS = ['ltr', 'rtl'] as const;
